import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { DiscountPromoCollection } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class DiscountPromotionApi {
    public static getDiscountPromotion(_xmStore: XmStore, http: HttpClient): Observable<DiscountPromoCollection> {

        return http.get('/account/promotion', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: DiscountPromoCollection) => DiscountPromoCollection.create<DiscountPromoCollection>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_DISCOUNT_PROMOTION] = DiscountPromotionApi.getDiscountPromotion;
